import React from 'react';

const ClockIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </svg>
);

const EyeIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

function fmtCount(n) {
    const v = Number(n) || 0;
    if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    if (v >= 1_000) return `${(v / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
    return String(v);
}

const FreshBadge = () => (
    <span className="inline-flex items-center text-[12px] font-medium px-[8px] py-[1px] rounded-[6px] bg-[#34D399] text-[#FFFFFF]">
        Mới cập nhật
    </span>
);

function pickTitle(detail) {
    if (detail?.title) return detail.title;
    const summary = detail?.summary || '';
    const firstLine = summary.split('\n').find((s) => s.trim().length > 0) || '';
    const clean = firstLine.replace(/^#+\s*/, '').trim();
    return clean || `${detail?.symbol || ''} · ${detail?.category || ''}`;
}

function pickLead(detail, title) {
    const summary = (detail?.summary || '').trim();
    if (!summary) return '';
    const clean = summary.replace(/\n+/g, ' ').replace(/[#*_>`]/g, '').trim();
    if (title && clean.startsWith(title.trim())) {
        return clean.slice(title.trim().length).replace(/^[\s—–:.-]+/, '').trim();
    }
    return clean;
}

function formatDate(iso) {
    if (!iso) return '';
    try {
        const d = new Date(iso);
        const date = d.toLocaleDateString('vi-VN');
        const time = d.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
        return `${date} · ${time}`;
    } catch {
        return '';
    }
}

export default function DetailTitle({ detail }) {
    if (!detail) return null;
    const title = pickTitle(detail);
    const lead = pickLead(detail, title);
    const tags = detail.tags || [];
    const dateText = formatDate(detail.snapshot_at);
    const isFresh = detail.freshness === 'fresh';

    return (
        <section className="bg-white border border-[#ECECED] rounded-[16px] p-[16px] sm:p-[24px_32px] md:p-[32px_48px] [&>*:first-child]:!mt-0 [&>*:last-child]:!mb-0">
            <div className="flex items-center justify-between gap-[12px] flex-wrap mb-[16px]">
                <span className="inline-flex items-center text-[12px] font-bold px-[8px] py-[3px] rounded-[6px] bg-[#F5F5F5] text-[#111827]">
                    {detail.symbol}
                </span>
                <div className="flex items-center gap-[8px] text-[14px] text-[#636369]">
                    {dateText && (
                        <span className="inline-flex items-center gap-[6px]">
                            <ClockIcon /> {dateText}
                        </span>
                    )}
                    {Number(detail.view_count) > 0 && (
                        <span
                            className="inline-flex items-center gap-[6px]"
                            title={`${detail.view_count} lượt xem`}
                        >
                            <EyeIcon /> {fmtCount(detail.view_count)}
                        </span>
                    )}
                    {isFresh && <FreshBadge />}
                </div>
            </div>

            <h1 className="text-[24px] font-bold text-[#111827] leading-[32px] m-0 mb-[16px]">
                {title}
            </h1>

            {lead && (
                <p className="text-[16px] text-[#111827] leading-[24px] m-0 mb-[16px]">{lead}</p>
            )}

            {!!tags.length && (
                <div className="flex flex-wrap gap-[6px]">
                    {tags.map((t) => (
                        <span key={t} className="inline-flex text-[11px] bg-[#EFF6FF] text-[#1D4ED8] px-[8px] py-[2px] rounded-[999px]">
                            #{t}
                        </span>
                    ))}
                </div>
            )}
        </section>
    );
}
